module.exports = __webpack_public_path__ + "static/media/virtualmirror.7415fb35.png";